module.exports = __webpack_public_path__ + "static/Publix_pin-5976ff2c55739b208ac3b05edc80109a.png";